export default "__VITE_ASSET__BnoiVO9p__"